var _path, _path2, _g, _rect, _rect2, _circle, _circle2, _circle3, _rect3, _path3, _path4, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 62C25 52.0589 33.0589 44 43 44H137C146.941 44 155 52.0589 155 62V89.1483C155 93.6831 154.229 98.1848 152.72 102.461L135.239 151.991C132.699 159.187 125.896 164 118.265 164H61.7353C54.1036 164 47.3014 159.187 44.7614 151.991L27.2804 102.461C25.7711 98.1848 25 93.6831 25 89.1483L25 62Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 62C25 52.0589 33.0589 44 43 44H137C146.941 44 155 52.0589 155 62V89.1483C155 93.6831 154.229 98.1848 152.72 102.461L135.239 151.991C132.699 159.187 125.896 164 118.265 164H61.7353C54.1036 164 47.3014 159.187 44.7614 151.991L27.2804 102.461C25.7711 98.1848 25 93.6831 25 89.1483L25 62Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_38)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#84FFFF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 124,
    width: 8,
    height: 27,
    fill: "#0040AE",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 124,
    width: 36,
    height: 27,
    fill: "#0040AE",
    fillOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 138,
    r: 8,
    fill: "white",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 138,
    r: 12,
    fill: "black",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 138,
    r: 8.16,
    fill: "black",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 86C38 81.5817 41.5817 78 46 78H134C138.418 78 142 81.5817 142 86V104C142 108.418 138.418 112 134 112H120.981C117.711 112.167 115.5 113.137 114.005 114.347C113.518 114.741 113.024 115.163 112.522 115.593C110.047 117.708 107.365 120 104.278 120H90H76.6676C73.5324 120 70.732 117.871 68.0462 115.829L68.0461 115.829C67.096 115.106 66.1602 114.395 65.229 113.792C63.7725 112.85 61.7704 112.141 59.0192 112H46C41.5817 112 38 108.418 38 104V86Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 78,
    width: 104,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 86C38 81.5817 41.5817 78 46 78H134C138.418 78 142 81.5817 142 86V104C142 108.418 138.418 112 134 112H120.981C117.711 112.167 115.5 113.137 114.005 114.347C113.518 114.741 113.024 115.163 112.522 115.593C110.047 117.708 107.365 120 104.278 120H90H76.6676C73.5324 120 70.732 117.871 68.0462 115.829L68.0461 115.829C67.096 115.106 66.1602 114.395 65.229 113.792C63.7725 112.85 61.7704 112.141 59.0192 112H46C41.5817 112 38 108.418 38 104V86Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 95C50 92.2386 52.2386 90 55 90H125C127.761 90 130 92.2386 130 95V97C130 99.7614 127.761 102 125 102H112.981C109.711 102.167 107.5 103.137 106.005 104.347C105.518 104.741 105.024 105.163 104.522 105.593C102.518 107.305 100.38 109.133 98 109.767V110H96.2779H90H84.6676C81.5324 110 78.732 107.871 76.0462 105.829L76.0461 105.829C75.096 105.106 74.1602 104.395 73.229 103.792C71.7725 102.85 69.7704 102.141 67.0192 102H55C52.2386 102 50 99.7614 50 97V95Z",
    fill: "#FF3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 120L70 74H66L46 120H50ZM88 74H77L57 120H68L88 74Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot2);
export default __webpack_public_path__ + "static/media/bot-2.8a49890e51cdc1631d8e6b9b1f07336e.svg";
export { ForwardRef as ReactComponent };